import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import { SignalIdunaLogo } from "@App/Components/atoms/whitelabel/logos/SignalIdunaLogo";
import type { Config } from "@App/configs/interfaces";
import { claimNumberFieldIsRequired } from "@App/utils/whitelabel/conditionals/signalIduna/claimNumberFieldIsRequired";
import { showClaimNumberField } from "@App/utils/whitelabel/conditionals/signalIduna/showClaimNumberField";

/**
 * Configuration for the Signal Iduna whitelabel.
 * Extends the default configuration with specific settings for Signal Iduna.
 */
export const config: Partial<Config> = {
  slug: "signal-iduna",
  navbar: {
    logos: {
      left: {
        component: <RepareoLogo />,
      },
      right: {
        component: <SignalIdunaLogo />,
      },
    },
  },
  reviews: {
    show: true,
  },
  garageList: {
    maxRecommendedGarages: 1,
  },
  checkout: {
    vin: {
      display: false,
    },
    claimNumber: {
      display: showClaimNumberField,
      required: claimNumberFieldIsRequired,
      regex:
        /^(?:\d{3,8}(?:TK|VK|KH)\d{2}\d{1,5}|(?:\d{1,2}(?:\.\d{3}){1,2}|\d{3}\.\d{3})\/(?:TK|VK|KH)\d{2}\/\d{1,5})$/,
    },
    contractNumber: {
      display: false,
    },
    optIns: {
      reviewOptIn: {
        show: false,
      },
    },
  },
};

export default config;
